'use client';

import type Lenis from 'lenis';

type SpartanProductScrollSubscriber = () => void;

let activeLenis: Lenis | undefined;
const subscribers = new Set<SpartanProductScrollSubscriber>();

export const getSpartanProductLenis = (): Lenis | undefined => activeLenis;

export const setSpartanProductLenis = (lenis: Lenis | undefined): void => {
  activeLenis = lenis;

  if (typeof window !== 'undefined') {
    (window as unknown as { lenis?: Lenis }).lenis = lenis;
  }

  subscribers.forEach((subscriber) => subscriber());
};

export const subscribeSpartanProductScroll = (
  subscriber: SpartanProductScrollSubscriber
): (() => void) => {
  subscribers.add(subscriber);

  return () => {
    subscribers.delete(subscriber);
  };
};

export const notifySpartanProductScroll = (): void => {
  subscribers.forEach((subscriber) => subscriber());
};

export const refreshSpartanProductScroll = (): void => {
  activeLenis?.resize();
  notifySpartanProductScroll();
};
